var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.551 4.082a1.66 1.66 0 0 1 1.9.787l10.336 18.375c.226.4.267.855.152 1.265a1.66 1.66 0 0 1-1.603 1.216H4.664a1.66 1.66 0 0 1-1.177-.488 1.66 1.66 0 0 1-.274-1.993L13.549 4.869a1.66 1.66 0 0 1 1.002-.787z",
    stroke: "#CE0B24",
    strokeWidth: 1.95
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#CE0B24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#CE0B24",
    strokeWidth: 0.75,
    d: "M13.94 20.441h2.12v2.284h-2.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.6a1.55 1.55 0 0 1 1.546 1.647l-.402 6.38a1.146 1.146 0 0 1-2.288 0l-.402-6.38A1.55 1.55 0 0 1 15 9.6z",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-warning.6f55423b43b54c0ed8cfe00f4f0635eb.svg";